module.exports = __webpack_public_path__ + "static/media/QATAR.c9f5665d.png";